import type { WoelbungForm } from './woelbung-symbol';
import { blockFacetten, BLOCK_VIEWBOX, type Facette } from './gelaende-block';

/**
 * Schraegbild zu einer Woelbungsstufe: ein Stueck Hang von schraeg oben, damit
 * man sieht, wie die Flaeche tatsaechlich liegt.
 *
 * Die Flaeche entsteht aus drei Anteilen:
 *   1. eine leichte Grundneigung, damit erkennbar ist, wo bergab ist,
 *   2. die VERTIKALE Woelbung in Gefaellrichtung (Kuppe oder Mulde im Profil),
 *   3. die HORIZONTALE Woelbung quer dazu (Ruecken oder Tiefenlinie).
 *
 * Fachlich interessant sind vor allem die gemischten Stufen: konvex-konkav
 * ergibt einen Sattel, also eine Flaeche, die sich in der einen Richtung
 * aufwoelbt und in der anderen einsenkt.
 *
 * Gezeichnet wird mit dem gemeinsamen Gelaendeblock (`gelaende-block.ts`) -
 * derselbe Blickwinkel und derselbe Bodensockel wie bei Neigung und Einbindung.
 */

/** Zeichenflaeche des Schraegbildes (Breite x Hoehe). */
export const RAUMBILD_VIEWBOX = BLOCK_VIEWBOX;

export type { Facette };

/** Ausschlag der Woelbung je Richtung. */
const WOELBUNG = 0.42;
/** Grundneigung des Hanges (bergab nach vorn). */
const NEIGUNG = 0.3;

/**
 * Hoehe der Flaeche an einer Stelle.
 *
 * @param laengs Lage in Gefaellrichtung, -1 = bergauf/hinten, +1 = bergab/vorn
 * @param quer   Lage quer zum Hang, -1 bis +1
 */
export function raumbildHoehe(vertikal: WoelbungForm, horizontal: WoelbungForm, laengs: number, quer: number): number {
	return -NEIGUNG * laengs + woelbungsanteil(vertikal, laengs) + woelbungsanteil(horizontal, quer);
}

/** Die Facetten des Schraegbildes zu einer Woelbungsstufe. */
export function raumbildFacetten(vertikal: WoelbungForm, horizontal: WoelbungForm): Facette[] {
	return blockFacetten((laengs, quer) => raumbildHoehe(vertikal, horizontal, laengs, quer));
}

/** Woelbungsanteil einer Richtung: in der Mitte am staerksten, am Rand null. */
function woelbungsanteil(form: WoelbungForm, t: number): number {
	const bogen = WOELBUNG * (1 - t * t);
	if (form === 'konvex') return bogen;
	if (form === 'konkav') return -bogen;
	return 0;
}
